import { Grid, Card, Box } from "@mui/material";
import CreateUserIcon from "../../assets/images/add-user.png";
import Createcontract from "../../assets/images/edit.png";
import Account from "../../assets/images/account.png";
import Medical from "../../assets/images/medical.png";

import { ConnectionContext, UserContext } from "App";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "App";
import { useNavigate } from "react-router-dom";
import MDButton from "components/MDButton";
import React from "react";

import { Bar, Chart } from "react-chartjs-2";

import { Line } from "react-chartjs-2";
import MDTypography from "components/MDTypography";
import UsersApi from "Classes/API/UsersApi";
const MemoizedBarChart = React.memo(({ data, options }) => <Bar data={data} options={options} />);

const MemoizedLineChart = React.memo(({ data }) => <Line data={data} />);

const initialHistogramData = {
  labels: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ],
  datasets: [
    {
      label: "Users Per Month",
      data: Array(12).fill(0),
      backgroundColor: "rgba(75, 192, 192, 0.6)",
      borderColor: "rgba(75, 192, 192, 1)",
      borderWidth: 1,
    },
  ],
};

const initialChartData = {
  labels: Array.from({ length: 24 }, (_, i) => `${i}:00`),
  datasets: [
    {
      label: "New Patients",
      data: Array(24).fill(0),
      fill: true,
      backgroundColor: "rgba(75, 192, 255, 0.2)",
      borderColor: "rgba(75,192,266,1)",
    },
    {
      label: "Acc Sessions for the Day",
      data: Array(24).fill(0),
      fill: false,
      borderColor: "#3560AD",
    },
  ],
};

const histogramOptions = {
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        precision: 0,
      },
    },
  },
};

function Dashboard({}) {
  const navigate = useNavigate();
  function handleOnClick(url) {
    navigate(url, { replace: true }), [navigate];
  }
  const [BroadcastMessage, setBroadcastMessage] = useState("");
  const User = useContext(UserContext);
  const { translations } = useContext(LanguageContext);
  const Connection = useContext(ConnectionContext);
  const [histogramData, setHistogramData] = useState(initialHistogramData);
  const [chartData, setChartData] = useState(initialChartData);

  //console.log("UserData in DashBoard", User);

  useEffect(() => {
    const fetchUsersPerMonth = async () => {
      try {
        let response = await UsersApi.GetUsersPerMonth(); // Await for response to be returned

        // Initialize data array for each month (January to December)
        let monthlyData = Array(12).fill(0);

        // If response is successful, extract the data
        if (response && response.data && response.status === "Success") {
          const data = response.data;

          // Populate the monthlyData array with the counts from the response
          data.forEach((monthInfo) => {
            if (monthInfo.month >= 1 && monthInfo.month <= 12) {
              // Subtract 1 from month index to map it to array (0-based index)
              monthlyData[monthInfo.month - 1] = monthInfo.count;
            }
          });
        }

        // Set the chart data with updated monthly user data
        setHistogramData((prevState) => ({
          ...prevState,
          datasets: [
            {
              ...prevState.datasets[0],
              data: monthlyData,
            },
          ],
        }));
      } catch (error) {
        console.error("Error fetching users per month data", error);
      }
    };

    fetchUsersPerMonth();
  }, []); // Empty dependency array to run once after initial render

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Await the response from the API call
        const response = await UsersApi.GetDailyStats();

        // Initialize data as empty in case of failure
        let data = { newPatients: [], sessions: [] };

        if (response && response.status === "Success") {
          data = response.data; // Assign the response data if status is Success
          //console.log("Data", data);
        }

        // Extract labels and datasets
        const labels = Array.from({ length: 24 }, (_, i) => `${i}:00`);
        const newPatientsData = Array(24).fill(0);
        const sessionsData = Array(24).fill(0);

        // Fill new patients data by hour if newPatients array exists
        if (data.newPatients && data.newPatients.length > 0) {
          data.newPatients.forEach((patient) => {
            if (patient.hour !== undefined && patient.hour >= 0 && patient.hour < 24) {
              newPatientsData[patient.hour] = patient.count;
            }
          });
        }

        // Fill sessions data by hour if sessions array exists
        if (data.sessions && data.sessions.length > 0) {
          data.sessions.forEach((session) => {
            if (session.hour !== undefined && session.hour >= 0 && session.hour < 24) {
              sessionsData[session.hour] = session.count;
            }
          });
        }

        // Update chart data
        setChartData({
          labels: labels,
          datasets: [
            {
              ...chartData.datasets[0],
              data: newPatientsData,
            },
            {
              ...chartData.datasets[1],
              data: sessionsData,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching data", error);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run once after initial render

  if (User.isActivated === false) {
    return <div>You are not active</div>;
  } else if (User.isSoftDeleted === true) {
    return <div>You are soft deleted</div>;
  }
  const GetId = () => {
    switch (User.userType) {
      case "Admin":
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type: </b> Admin ||{" "}
            <b style={{ color: "#3560AD" }}>ID:</b> {User.id}
          </>
        );
      case "SubAdmin":
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type: </b> Sub Admin ||{" "}
            <b style={{ color: "#3560AD" }}>ID:</b> {User.id}
          </>
        );
      case "AppointmentEmployee":
      case "AccountingEmployee":
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type:</b> {User.userType} || User ID: {User.id},
            EmployeeId: {User.getEmployee.id}
          </>
        );
      case "FloorManager":
      case "Therapist":
      case "Patient":
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type:</b> {User.userType}
          </>
        );

      case "UnAssigned":
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type:</b> UnAssigned
          </>
        );
      default:
        return (
          <>
            <b style={{ color: "#3560AD" }}>User Type:</b> UnKnown
          </>
        );
    }
  };

  const SendBroadcast = async () => {
    Connection.SendBroadcast(BroadcastMessage);
  };

  return User.userType === "Admin" ? (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "1em", fontSize: 18 }}>
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: "#3560AD", display: "flex", justifyContent: "space-between" }}>
            <b> Nice to meet you again : </b> <span style={{ color: "#333" }}> {User.name} </span>
          </span>
          {
            <span>
              {GetId()}
              {/* <input
                type="text"
                value={BroadcastMessage}
                onChange={(e) => setBroadcastMessage(e.target.value)}
                className="ml-3"
              />
              <MDButton
                sx={{
                  backgroundColor: "#3560AD",
                  color: "white !important", // Explicitly set text color
                  "&:hover": {
                    backgroundColor: "#4682B4",
                    color: "white !important", // Ensure text stays white on hover
                  },
                  marginLeft: "7px",
                }}
                onClick={SendBroadcast}
              >
                {translations.DashBoardBroadcast}
              </MDButton> */}
            </span>
          }
        </MDBox>
      </Card>

      <div className="container-fluid mt-3">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "8px",
                margin: "0.5rem",
              }}
            >
              <MDTypography>User Line</MDTypography>
              <MemoizedLineChart data={chartData} />
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div
              style={{
                backgroundColor: "#fff",
                padding: "10px",
                borderRadius: "8px",
                margin: "0.5rem",
              }}
            >
              <MDTypography>User Histogram</MDTypography>
              <MemoizedBarChart data={histogramData} options={histogramOptions} />
            </div>
          </Grid>
          {/* Card 1 */}
          <Grid item xs={12} sm={6} md={7}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Accountingsessions")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src={Account}
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.sidebarChildernAccountingAccountingSessions}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 2 */}
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Appointments")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/942/942759.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardAppointments}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 3 */}
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Appointments/FeedbackStatistics")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1321/1321907.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardFeedbackStatistics}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 4 */}
          <Grid item xs={12} sm={6} md={7}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/DomesticStays/CreateDomesticStay")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src={Medical}
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.sidebarChildernAccountingCreateInPatientStay}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 5 */}
          <Grid item xs={12} sm={6} md={7}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Accountingsessions/Packages/CreateMultiPackage")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/126/126165.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardCreateMultiPackages}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 6 */}
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/PatientList")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn.icon-icons.com/icons2/2266/PNG/512/crowd_patient_patients_icon_140474.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardPatients}
                </span>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/CreateUser")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src={CreateUserIcon}
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashboardCreateuser}
                </span>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={7}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Contracts/CreateContract")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src={Createcontract}
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashboardCreatecontract}
                </span>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </div>
    </DashboardLayout>
  ) : User.userType === "Therapist" ? (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "1em", fontSize: 18 }}>
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <span>
            <b style={{ color: "#3366cc" }}> User Name : </b> {User.name} || {GetId()}
          </span>
          <span>
            <input
              type="text"
              value={BroadcastMessage}
              onChange={(e) => setBroadcastMessage(e.target.value)}
              className="ml-3"
            />
            <button className="btn btn-primary ml-2" onClick={SendBroadcast}>
              Broadcast
            </button>
          </span>
        </MDBox>
      </Card>

      <div className="container-fluid mt-3">
        <Grid container spacing={2}>
          {/* Card 1: Appointments */}
          <Grid item xs={12} sm={6} md={6}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                },
              }}
              onClick={() => handleOnClick("/Appointments")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/942/942759.png"
                  alt="Appointments"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardAppointments}
                </span>
              </Box>
            </Card>
          </Grid>

          {/* Card 2: Patients */}
          <Grid item xs={12} sm={6} md={6}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                },
              }}
              onClick={() => handleOnClick("/PatientList")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn.icon-icons.com/icons2/2266/PNG/512/crowd_patient_patients_icon_140474.png"
                  alt="Patients"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardPatients}
                </span>
              </Box>
            </Card>
          </Grid>

          <div className="col-md-4 mt-4">
            <Card
              sx={{ padding: "1em", fontSize: 18, cursor: "pointer" }}
              onClick={handleOnClick.bind(this, "/Accountingsessions")}
            >
              <MDBox>
                <div className="row">
                  <div className="col-md-4">
                    <img
                      src={"https://cdn-icons-png.flaticon.com/512/5023/5023406.png"}
                      alt="Profile"
                      className="img-fluid"
                    />
                  </div>
                  <div
                    className="col-md-8"
                    style={{
                      textAlign: "center",
                      fontSize: "22px",
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Accounting sessions
                  </div>
                </div>
              </MDBox>
            </Card>
          </div>
        </Grid>
      </div>
    </DashboardLayout>
  ) : User.userType === "SubAdmin" ? (
    <DashboardLayout>
      <DashboardNavbar />
      <Card sx={{ padding: "1em", fontSize: 18 }}>
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: "#3560AD", display: "flex", justifyContent: "space-between" }}>
            <b> Nice to meet you again : </b> <span style={{ color: "#333" }}> {User.name} </span>
          </span>
          {
            <span>
              {GetId()}
              {/*  <input type="text" value={BroadcastMessage} onChange={(e) => setBroadcastMessage(e.target.value)} className="ml-3" />
              <MDButton sx={{ backgroundColor: '#3560AD', '&:hover': { backgroundColor: '#4682B4' }, marginLeft: "7PX" }} color="text" onClick={SendBroadcast}>{translations.DashBoardBroadcast}</MDButton> */}
            </span>
          }
        </MDBox>
      </Card>
      <div className="container-fluid mt-3">
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/Appointments")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn-icons-png.flaticon.com/512/942/942759.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardAppointments}
                </span>
              </Box>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6} md={5}>
            <Card
              sx={{
                padding: "1em",
                fontSize: 18,
                cursor: "pointer",
                "&:hover": {
                  boxShadow: 3,
                  transform: "scale(1.02)",
                  backgroundColor: "#3560AD",
                  color: "#fff",
                },
              }}
              onClick={() => handleOnClick("/PatientList")}
            >
              <Box display="flex" alignItems="center">
                <img
                  src="https://cdn.icon-icons.com/icons2/2266/PNG/512/crowd_patient_patients_icon_140474.png"
                  alt="Profile"
                  className="img-fluid"
                  style={{ width: "60px", height: "60px", marginRight: "1em" }}
                />
                <span style={{ fontSize: "22px", fontWeight: "bold" }}>
                  {translations.DashBoardPatients}
                </span>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </div>
    </DashboardLayout>
  ) : (
    <DashboardLayout>
      <DashboardNavbar />

      <Card sx={{ padding: "1em", fontSize: 18 }}>
        <MDBox sx={{ display: "flex", justifyContent: "space-between" }}>
          <span>
            <b style={{ color: "#3366cc" }}> User Name : </b> {User.name} || {GetId()}
          </span>
          <span>
            <input
              type="text"
              value={BroadcastMessage}
              onChange={(e) => setBroadcastMessage(e.target.value)}
              className="ml-3"
            />
            <button className="btn btn-primary ml-2" onClick={SendBroadcast}>
              Broadcast
            </button>
          </span>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
}

export default Dashboard;
